import PageLoadedQueue
    from "../../../../../../../Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/PageLoadedQueue";
import {
    initFixedFilters
} from "../../../../../../../Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/Plugins/FixedFilters";

interface FilterValuesForApi {
    cities: string,
    targetGroups: string,
    topics: string,
    steps: string,
    keywords: string,
    page: number,
    limit: number,
    toDate: string,
    fromDate: string,
    showOnlyFutureEvents: boolean,
}

const getValuesForFilter = (
    listElement: HTMLElement,
    filterElement: HTMLElement,
    page: number = null,
    limit: number = null,
    fromDate: string = null,
    toDate: string = null,
    showOnlyFutureEvents: boolean = true,
    initialDefaults = {}
): FilterValuesForApi => {

    const listLimit = parseInt(listElement.dataset.eventlistLimit);

    let values: FilterValuesForApi = {
        ...initialDefaults,
        page,
        limit: limit ?? listLimit,
        toDate: null,
        fromDate: null,
        showOnlyFutureEvents
    } as FilterValuesForApi;

    if (fromDate && toDate) {
        values.fromDate = fromDate;
        values.toDate = toDate;
    }

    if (filterElement instanceof HTMLElement) {
        const inputs = filterElement.querySelectorAll('input, select');

        inputs.forEach((input) => {
            if (input instanceof HTMLSelectElement) {

                if (input.options.length === 0) {
                    return;
                }

                if (input.multiple) {
                    const selectedOptions = input.selectedOptions;
                    values[input.name] = Array.from(selectedOptions).map((option) => option.value ? option.value : null).filter(Boolean);
                    return;
                }

                if (input.value) {
                    values[input.name] = input.value;
                }

                return;
            }

            if (input instanceof HTMLInputElement && input.value) {
                values[input.name] = input.value;
            }
        });
    }

    return values;
}

export function initEventList(eventListWrapper: HTMLElement) {
    if (eventListWrapper.dataset.enventlistInitialized === '1') {
        return;
    }

    eventListWrapper.dataset.enventlistInitialized = '1';

    const listElement = eventListWrapper.querySelector('.event-list') as HTMLElement;
    const filterElement = eventListWrapper.querySelector('.event-list-filter') as HTMLElement;
    const filterPlaceholder = eventListWrapper.querySelector('.event-list-filter--placeholder') as HTMLElement;
    const listPlaceholder = eventListWrapper.querySelector('.event-list--placeholder') as HTMLElement;
    const buttonLoadMore = eventListWrapper.querySelector('.event-list--load-more') as HTMLButtonElement;
    const loadingSpinner = eventListWrapper.querySelector('.event-list--loading-spinner') as HTMLElement;
    const endlessLoadTrigger = eventListWrapper.querySelector('.event-list--load-more-endless-trigger') as HTMLElement;

    let activeFiltersElement = null;
    let activeFiltersListElement = null;
    let activeFiltersToggleElement = null;
    let filterSearchInput: HTMLInputElement = null;
    let filterSubmitButton: HTMLButtonElement = null;
    let filterValueButtons: HTMLButtonElement[] = [];
    let initialDefaults = {
        cities: listElement.dataset.eventlistSelectedCities ? JSON.parse(listElement.dataset.eventlistSelectedCities) : null,
        targetGroups: listElement.dataset.eventlistSelectedTargetGroups ? JSON.parse(listElement.dataset.eventlistSelectedTargetGroups) : null,
        topics: listElement.dataset.eventlistSelectedTopics ? JSON.parse(listElement.dataset.eventlistSelectedTopics) : null,
        steps: listElement.dataset.eventlistSearchSteps,
        keywords: listElement.dataset.eventlistSearchKeywords
    };

    const apiUrl = listElement.dataset.eventlistUri;
    let page = parseInt(listElement.dataset.eventlistPage) ?? 0;
    const limit = parseInt(listElement.dataset.eventlistLimit) ?? 10;
    const endlessScroll = listElement.dataset.eventlistEndlessScroll == "1";
    const showOnlyFutureEvents = listElement.dataset.eventlistShowOnlyFutureEvents == "1";
    const fromDate = listElement.dataset.eventlistFromDate;
    const toDate = listElement.dataset.eventlistToDate;
    let abortController: AbortController = null;
    let observer: IntersectionObserver = null;

    let firstRequest = true;
    let firstFilterRequest = true;
    let requestIsRunning = false;
    let listIsReady = false;
    let filterIsReady = false;
    let initialized = false;

    /**
     * Initialize the filter
     */
    const initFilter = async () => {
        if (!filterElement) {
            filterIsReady = true;
            return;
        }

        filterIsReady = false;

        const filterApiUrl = filterElement.dataset.eventlistFilterUri;
        const uri = new URL(filterApiUrl, window.location.origin);

        const response = await fetch(uri.href, {
            method: 'POST',
            headers: {
                'Accept': 'text/html',
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify(getValuesForFilter(listElement, filterElement, page, limit, fromDate, toDate, showOnlyFutureEvents, initialDefaults)),
        });

        filterElement.innerHTML = await response.text();
        const filterLoading = eventListWrapper.querySelector('.filter-boxes--loading') as HTMLElement;
        filterLoading?.classList.remove('show');

        // @ts-ignore
        $(filterElement).find('select.selectpicker').selectpicker({
            style: ''
        });

        filterSearchInput = filterElement.querySelector('input[type="search"]') as HTMLInputElement;
        filterSubmitButton = filterElement.querySelector('button[type="submit"]') as HTMLButtonElement;
        activeFiltersElement = filterElement.querySelector('.filter-boxes__active-filters') as HTMLElement;
        activeFiltersListElement = filterElement.querySelector('.filter-boxes__active-filters__list') as HTMLElement;
        activeFiltersToggleElement = filterElement.querySelector('.filter-boxes__active-filters__toggle a') as HTMLElement;
        filterValueButtons = Array.from(filterElement.querySelectorAll<HTMLButtonElement>('.filter-value'));

        filterSearchInput.addEventListener('keyup', async (event: KeyboardEvent) => {
            if (!filterIsReady) {
                event.preventDefault();
                return false;
            }
            if (event.key === 'Enter' || event.code === '13') {
                await newFilterRequest();
            }
        });

        filterSubmitButton.addEventListener('click', async (event) => {
            if (!filterIsReady) {
                event.preventDefault();
                return false;
            }
            await newFilterRequest();
        });

        filterElement.querySelectorAll('select').forEach((selectElement) => {
            selectElement.addEventListener('change', async (event) => {
                if (!filterIsReady) {
                    event.preventDefault();
                    return false;
                }
                await newFilterRequest();
            });
        });

        activeFiltersToggleElement?.addEventListener('click', async (event) => {

            if (!filterIsReady) {
                event.preventDefault();
                return false;
            }

            activeFiltersToggleElement.classList.add('removing');

            if (filterSearchInput instanceof HTMLInputElement) {
                filterSearchInput.value = '';
            }

            if (filterElement instanceof HTMLElement) {
                const selects = filterElement.querySelectorAll('select');

                selects.forEach((select: HTMLSelectElement) => {
                    if (select.multiple) {
                        const options = Array.from(select.options);
                        options.forEach((option) => {
                            option.selected = false;
                        });
                    } else {
                        select.selectedIndex = -1;
                    }
                });
            }

            await newFilterRequest();
        });

        filterValueButtons.forEach((filterValueButton) => {
            filterValueButton.addEventListener('click', async (event) => {
                filterValueButton.classList.add('removing');
                const selectOption: HTMLOptionElement = filterElement.querySelector(`select[name="${filterValueButton.dataset.filter}"] option[value="${filterValueButton.dataset.value}"]`)
                if (selectOption) {
                    selectOption.selected = false;
                }
                if (initialDefaults[filterValueButton.dataset.filter] && Array.isArray(initialDefaults[filterValueButton.dataset.filter])) {
                    initialDefaults[filterValueButton.dataset.filter] = initialDefaults[filterValueButton.dataset.filter].filter(
                        value => value !== filterValueButton.dataset.value
                    );
                } else if (initialDefaults[filterValueButton.dataset.filter]) {
                    delete initialDefaults[filterValueButton.dataset.filter];
                }
                await newFilterRequest();
            });
        });

        initFixedFilters();

        filterIsReady = true;
        togglePlaceholders();
    }

    const newFilterRequest = async () => {

        listIsReady = false;
        filterIsReady = false;

        // abort the old request if a new one is started
        if (requestIsRunning) {
            abortController?.abort('Abort last request due to new request.');
            abortController = new AbortController();
            requestIsRunning = false;
        }

        if (!firstFilterRequest) {
            showListPlaceholder(true);
            listElement.innerHTML = '';
            page = 0;
            firstFilterRequest = true;
            requestIsRunning = false;
        }

        await initFilter();
        await loadMoreEventsAction();
    }

    /**
     * Get the events from the API
     */
    const getEvents = async () => {
        requestIsRunning = true;

        const uri = new URL(apiUrl, window.location.origin);
        const response = await fetch(uri.href, {
            method: 'POST',
            headers: {
                'Accept': 'text/html',
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify(getValuesForFilter(listElement, filterElement, page, limit, fromDate, toDate, showOnlyFutureEvents, initialDefaults)),
            signal: abortController?.signal
        });

        listIsReady = true;

        return await response.text();
    }

    /**
     * Load the events
     */
    const loadEvents = async () => {
        if (!firstFilterRequest) showLoadingSpinner(true);
        const events = await getEvents();

        if (firstFilterRequest) {
            listElement.innerHTML = events;

            if (!endlessScroll) {
                buttonLoadMore.classList.remove('d-none');
            }
        } else {
            listElement.innerHTML += events;
        }

        firstFilterRequest = false;
        requestIsRunning = false;
        page++;

        showLoadingSpinner(false);

        if (events == '') {
            buttonLoadMore.style.display = 'none';
            buttonLoadMore.disabled = true;
            buttonLoadMore.removeEventListener('click', loadMoreEventsAction);

            if (observer) {
                observer.unobserve(endlessLoadTrigger);
            }
        }
    }

    /**
     * Load more events action
     */
    const loadMoreEventsAction = async () => {
        if (requestIsRunning) return;
        await loadEvents();

        togglePlaceholders();
    }

    /**
     * Show the loading spinner (for appending the list)
     */
    const showLoadingSpinner = (showPlaceholder: boolean = true) => {
        if (!showPlaceholder) {
            loadingSpinner.classList.add('d-none');
            return;
        }

        loadingSpinner.classList.remove('d-none');
    }

    /**
     * Show the list placeholder (before loading the new list)
     */
    const showListPlaceholder = (showPlaceholder: boolean = true) => {
        if (!showPlaceholder) {
            listPlaceholder.classList.add('d-none');
            listElement.classList.remove('d-none');
            return;
        }

        listPlaceholder.classList.remove('d-none');
        listElement.classList.add('d-none');
    }

    /**
     * hides the filter and list placeholders if all information is loaded
     */
    const togglePlaceholders = () => {
        if (listIsReady && filterIsReady && !initialized) {
            filterPlaceholder?.classList.add('d-none');
            filterElement?.classList.remove('d-none');

            showListPlaceholder(false);

            if (endlessScroll && !initialized) {
                observer = new IntersectionObserver((entries: IntersectionObserverEntry[], obj: IntersectionObserver) => {
                    entries.forEach(entry => {
                        if (entry.target === endlessLoadTrigger && entry.isIntersecting && initialized) {
                            loadMoreEventsAction();
                        }
                    });
                });
                observer.observe(endlessLoadTrigger);
            }

            initialized = true;
        }

        if (initialized && listIsReady) {
            showLoadingSpinner(false);
            showListPlaceholder(false);
        }
    }

    if (!endlessScroll) {
        buttonLoadMore.addEventListener('click', loadMoreEventsAction, {passive: true});
    }

    const initialize = async () => {
        await Promise.all([loadMoreEventsAction(), initFilter()]);
        firstRequest = false;
    }

    initialize();
}

PageLoadedQueue.addFunction(() => {
    const eventListElements = document.querySelectorAll('.event-list-wrapper:not([data-enventlist-initialized="1"])');
    eventListElements.forEach((element) => {
        initEventList(element as HTMLElement);
    });
})

document.addEventListener('plandent.html.changed', () => {
    const eventListElements = document.querySelectorAll('.event-list-wrapper:not([data-enventlist-initialized="1"])');
    eventListElements.forEach((element) => {
        initEventList(element as HTMLElement);
    });
})
